import { createContext, useCallback, useContext } from "react";
import { childPath } from "../utils/child-path";

/**
 * Provides the flow-specific path prefix (e.g. "/dla-bliskich", "/odbierz-voucher")
 * to all descendants of a flow's Content component.
 *
 * The prefix is set at the flow root (FreePackagesContent, FriendsAndFamilyContent,
 * PurchaseProductsContent) using the match.path from `useRouteMatch()`. Nested pages
 * use `useFlowPath()` to build absolute paths within the unified BrowserRouter basename
 * (e.g. `flowPath(routes.checkout.raw())` → "/dla-bliskich/podsumowanie").
 *
 * Without this, `history.push(routes.X.raw())` would push plain "/podsumowanie" which
 * does not match any top-level Route and falls through to DistributionNotFound.
 */
const FlowPathContext = createContext<string>("/");

export const FlowPathProvider = FlowPathContext.Provider;

export const useFlowPath = () => {
  const prefix = useContext(FlowPathContext);
  return useCallback((relative: string) => childPath(prefix, relative), [prefix]);
};
